class HomepageComparisonTable extends HTMLElement {
  constructor() {
    super();
    this.currentIndex = 0;
    this.totalComps = parseInt(this.dataset.compCount) || 4;
    this.touchStartX = 0;
  }

  connectedCallback() {
    this.dots = this.querySelectorAll('.hp-comparison-table__dot');
    this.arrow = this.querySelector('.hp-comparison-table__arrow');
    this.card = this.querySelector('.hp-comparison-table__card');

    this.dots.forEach((dot, i) => {
      dot.addEventListener('click', () => this.goTo(i));
    });

    if (this.arrow) {
      this.arrow.addEventListener('click', () => this.next());
    }

    if (this.card) {
      this.card.addEventListener('touchstart', (e) => {
        this.touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      this.card.addEventListener('touchend', (e) => {
        const diff = this.touchStartX - e.changedTouches[0].screenX;
        if (diff > 50) this.next();
        else if (diff < -50) this.prev();
      }, { passive: true });
    }

    this.goTo(0);
  }

  goTo(index) {
    this.currentIndex = index;

    this.querySelectorAll('.hp-comparison-table__header-comp').forEach((el) => {
      el.classList.toggle('is-active', parseInt(el.dataset.comp) === index);
    });

    this.querySelectorAll('.hp-comparison-table__cell-comp').forEach((el) => {
      el.classList.toggle('is-active', parseInt(el.dataset.comp) === index);
    });

    this.dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === index);
    });
  }

  next() {
    this.goTo((this.currentIndex + 1) % this.totalComps);
  }

  prev() {
    this.goTo((this.currentIndex - 1 + this.totalComps) % this.totalComps);
  }
}

customElements.define('homepage-comparison-table', HomepageComparisonTable);
